(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4186);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1748);



function Image(props) {
    let { url , alt , sizes , className , style , width =400 , height , fitMode =_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .ImageFitMode.Clip */ .B.Clip  } = props;
    let srcset = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>{
        return [
            0.5,
            1,
            2
        ].map((multiplier)=>{
            if (!url) return "";
            let calculatedWidth = width * multiplier;
            let calculatedHeight = height ? height * multiplier : undefined;
            return "".concat((0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, calculatedWidth, calculatedHeight, fitMode), " ").concat(calculatedWidth, "w");
        }).join(",");
    }, [
        url
    ]);
    let fallback = url ? (0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, width, height) : "#";
    return fallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        srcSet: srcset,
        sizes: sizes,
        src: fallback,
        alt: alt,
        title: alt,
        className: className,
        style: style
    }) : null;
}


/***/ }),

/***/ 9707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageSpinner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./hooks/use-delayed-show.ts

function useDelayedShow() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    let [show, setShow] = react.useState(false);
    react.useEffect(()=>{
        let timeout = setTimeout(()=>{
            setShow(true);
        }, delay);
        return ()=>{
            try {
                clearTimeout(timeout);
            } catch (e) {
            // do nothing...
            }
        };
    });
    return show;
}

// EXTERNAL MODULE: ./components/atoms/spinner.tsx
var spinner = __webpack_require__(2999);
;// CONCATENATED MODULE: ./components/atoms/page-spinner.tsx




function PageSpinner() {
    let showSpinner = useDelayedShow();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-screen h-screen flex items-center justify-center",
        children: showSpinner && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
            size: 10
        })
    });
}


/***/ }),

/***/ 8045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AppBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@translator-app/react/lib/index.js
var lib = __webpack_require__(1477);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
;// CONCATENATED MODULE: ./utils/getMobileOS.ts
var MobileOS;
(function(MobileOS) {
    MobileOS[MobileOS["IOS"] = 0] = "IOS";
    MobileOS[MobileOS["Android"] = 1] = "Android";
    MobileOS[MobileOS["Other"] = 2] = "Other";
})(MobileOS || (MobileOS = {}));
function getMobileOS() {
    if (true) {
        // @ts-ignore
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return MobileOS.Android;
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        // @ts-ignore
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return MobileOS.IOS;
        }
    }
    return MobileOS.Other;
}

;// CONCATENATED MODULE: ./components/organisms/app-banner.tsx






const AppBanner = (props)=>{
    const { url  } = props;
    const { translate  } = (0,lib.useTranslator)();
    const [showAndroidPopup, setShowAndroidPopup] = (0,react.useState)(false);
    const iosMetadataContent = [
        "app-id=".concat(constants/* IOS_APP_ID */.N3)
    ];
    if (url) {
        iosMetadataContent.push("app-argument=".concat(url));
    }
    const androidUrl = "http://play.google.com/store/apps/details?id=".concat(constants/* ANDROID_APP_ID */.mE);
    (0,react.useEffect)(()=>{
        setShowAndroidPopup(getMobileOS() === MobileOS.Android);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "apple-itunes-app",
                    content: iosMetadataContent.join(", ")
                })
            }),
            showAndroidPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center p-4 px-8 mx-auto max-w-screen-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: translate("appBanner.downloadAppText")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "bg-blue-600 text-white rounded px-4 py-2 font-medium",
                            href: androidUrl,
                            children: translate("appBanner.viewButton")
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 9650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ GeneralPageHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const GeneralPageHeader = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: "relative h-16 bg-brand-500",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "absolute z-10 h-full w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-screen-xl mx-auto py-2 px-8 h-full flex items-center justify-between text-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/",
                    className: "font-bold text-lg",
                    children: "Woyti"
                })
            })
        })
    });
};


/***/ }),

/***/ 3485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ PageFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@translator-app/react/lib/index.js
var lib = __webpack_require__(1477);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
;// CONCATENATED MODULE: ./icons/mail.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fill: "currentColor",
  d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
});

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref);
};

/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ./icons/phone.svg
function phone_extends() { phone_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }



var phone_ref = /*#__PURE__*/react.createElement("path", {
  fill: "currentColor",
  d: "M497.39 361.8l-112-48a24 24 0 00-28 6.9l-49.6 60.6A370.66 370.66 0 01130.6 204.11l60.6-49.6a23.94 23.94 0 006.9-28l-48-112A24.16 24.16 0 00122.6.61l-104 24A24 24 0 000 48c0 256.5 207.9 464 464 464a24 24 0 0023.4-18.6l24-104a24.29 24.29 0 00-14.01-27.6z"
});

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/react.createElement("svg", phone_extends({
    viewBox: "0 0 512 512"
  }, props), phone_ref);
};

/* harmony default export */ var phone = (SvgPhone);
// EXTERNAL MODULE: ./utils/phonenumber.ts
var phonenumber = __webpack_require__(1311);
;// CONCATENATED MODULE: ./components/organisms/page-footer.tsx








const PageFooter = (props)=>{
    let { shop , organisation  } = props;
    let { translate  } = (0,lib.useTranslator)();
    let address = shop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-medium mb-2",
                children: shop.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    shop.address.street,
                    " ",
                    shop.address.streetNumber
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    shop.address.zipcode,
                    " ",
                    shop.address.city,
                    ", ",
                    shop.address.country
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "tel:".concat(shop.phonenumber),
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(phone, {
                            className: "w-4 h-4 mr-2",
                            "aria-label": "call"
                        }),
                        " ",
                        (0,phonenumber/* formatPhonenumber */.t)(shop.phonenumber)
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "mailto:".concat(shop.email),
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(mail, {
                            className: "w-4 h-4 mr-2",
                            "aria-label": "email"
                        }),
                        " ",
                        shop.email
                    ]
                })
            })
        ]
    }) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-t",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-screen-xl mx-auto mb-16 px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full text-gray-500 text-left lg:flex justify-between mt-8 mb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:flex justify-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-1",
                            children: address
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:flex flex-wrap font-bold justify-center mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mx-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:".concat((shop === null || shop === void 0 ? void 0 : shop.email) || constants/* SUPPORT_EMAIL */.Xy),
                                children: translate("footer.contactUs")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mx-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/privacy-policy",
                                passHref: true,
                                children: translate("footer.privacyPolicy")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mx-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/terms-conditions",
                                passHref: true,
                                children: translate("footer.termsConditions")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:mx-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/policies/cookie-policy",
                                passHref: true,
                                children: translate("footer.cookiePolicy")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap justify-between font-medium text-gray-700 my-2",
                    children: [
                        organisation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                organisation.companyName,
                                " - ",
                                organisation.vatNumber
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " BV Viresmo"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 1294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1748);




function SEO(props) {
    let { title ="" , description ="" , imageUrl =""  } = props;
    const processedImageUrl = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(()=>{
        if (imageUrl) {
            // Recommended image size by FB and Twitter
            return (0,_utils_imgix__WEBPACK_IMPORTED_MODULE_3__/* .generateImageLink */ .E)(imageUrl, 1200, 630, _utils_imgix__WEBPACK_IMPORTED_MODULE_3__/* .ImageFitMode.Fill */ .B.Fill);
        } else {
            return null;
        }
    }, [
        imageUrl
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,minimum-scale=1,initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            !!processedImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: processedImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            !!processedImageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: processedImageUrl
            })
        ]
    });
}


/***/ }),

/***/ 9169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FallbackPageTemplate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _organisms_general_page_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9650);
/* harmony import */ var _organisms_page_footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3485);
/* harmony import */ var _page_template__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3900);





const FallbackPageTemplate = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_page_template__WEBPACK_IMPORTED_MODULE_4__/* .PageTemplate */ .P, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_general_page_header__WEBPACK_IMPORTED_MODULE_2__/* .GeneralPageHeader */ .T, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-16 pb-96",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_organisms_page_footer__WEBPACK_IMPORTED_MODULE_3__/* .PageFooter */ .W, {})
        ]
    });
};


/***/ }),

/***/ 3900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ PageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
// EXTERNAL MODULE: ./contexts/theme-context.tsx
var theme_context = __webpack_require__(9746);
// EXTERNAL MODULE: ./components/organisms/seo.tsx
var seo = __webpack_require__(1294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./pages/_app.tsx + 70 modules
var _app = __webpack_require__(7479);
// EXTERNAL MODULE: ./components/atoms/page-spinner.tsx + 1 modules
var page_spinner = __webpack_require__(9707);
;// CONCATENATED MODULE: ./components/templates/router-loading.tsx





const RouterLoading = (props)=>{
    let { children  } = props;
    let router = (0,next_router.useRouter)();
    let [isLoading, setIsLoading] = react.useState(false);
    let [error, setError] = react.useState(null);
    react.useEffect(()=>{
        const routeChangeStartHandler = (url)=>{
            console.log("Route change start:", url);
            setIsLoading(true);
            setError(null);
        };
        const routeChangeCompleteHandler = (url)=>{
            console.log("Route change completed:", url);
            setIsLoading(false);
            setError(null);
        };
        const routeChangeErrorHandler = (err)=>{
            setIsLoading(false);
            setError(err);
            (0,_app.captureException)(err);
        };
        router.events.on("routeChangeStart", routeChangeStartHandler);
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        router.events.on("routeChangeError", routeChangeErrorHandler);
        return ()=>{
            router.events.off("routeChangeStart", routeChangeStartHandler);
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
            router.events.off("routeChangeError", routeChangeErrorHandler);
        };
    }, [
        router.events,
        setIsLoading
    ]);
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "fixed z-50 w-screen h-screen top-0 left-0 flex justify-center items-center",
            style: {
                backgroundColor: "rgba(255, 255, 255, 0.5)"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-lg font-md",
                        children: [
                            "Could not load the page ",
                            router.asPath
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Refresh the page to potentially resolve the issue, if it persists reach out to customer support."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-2",
                                children: [
                                    "Error Message: ",
                                    error.message
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            children,
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed z-50 w-screen h-screen top-0 left-0 flex justify-center items-center",
                style: {
                    backgroundColor: "rgba(255, 255, 255, 0.5)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_spinner/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var router_loading = (RouterLoading);

;// CONCATENATED MODULE: ./components/templates/page-template.tsx






const PageTemplate = (props)=>{
    let { children , brandColor =constants/* DEFAULT_BRAND_COLOR */.Iu , title , description , imageUrl  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_context/* ThemeProvider */.f6, {
        brandColor: brandColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(router_loading, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                    title: title || "Woyti",
                    description: description,
                    imageUrl: imageUrl || undefined
                }),
                children
            ]
        })
    });
};


/***/ }),

/***/ 4186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_atoms_heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2061);
/* harmony import */ var _components_atoms_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2881);
/* harmony import */ var _components_organisms_app_banner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8045);
/* harmony import */ var _components_organisms_error_boundary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3570);
/* harmony import */ var _components_organisms_general_page_header__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9650);
/* harmony import */ var _components_organisms_page_footer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3485);
/* harmony import */ var _components_templates_fallback_page_template__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9169);
/* harmony import */ var _components_templates_page_template__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3900);













const getShopLink = (shop, locale)=>{
    return "/".concat(locale, "/").concat(shop.organisation ? shop.organisation.pathname : "null", "/").concat(shop._id);
};
const PageImpl = (props)=>{
    let { shops  } = props;
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const sortedShops = shops.docs.sort((a, b)=>{
        const diff = b.woytiReservationsCount - a.woytiReservationsCount;
        if (diff !== 0) {
            return diff;
        }
        return a.name.localeCompare(b.name);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-gray-100 relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-brand-400 pb-36 h-96 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-brand-500 transform -rotate-6 h-96 -translate-x-12 -translate-y-64 z-0",
                        style: {
                            width: "150vw"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-24 z-10 flex justify-center w-full mb-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative max-w-screen-lg mt-8 w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full md:px-8 lg:pr-36",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-bold text-white text-3xl leading-8 mb-4 px-8",
                                        children: translate("homeScreen.findAWoyti")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "hidden lg:flex absolute z-0",
                                    style: {
                                        bottom: -64,
                                        right: 16
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/assets/illustrations/phone-girl-dark.svg",
                                            className: "h-48 w-auto"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/assets/illustrations/fridge.svg",
                                            className: "h-48 w-auto ml-4"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-xl mx-auto p-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_heading__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X, {
                        children: translate("homeScreen.shops")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid md:grid-cols-2 lg:grid-cols-3 gap-8",
                        children: sortedShops.map((shop)=>{
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: getShopLink(shop, router.locale),
                                className: "block rounded bg-white relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute block right-0 z-10 px-4 py-2 rounded-bl rounded-tr text-lg font-medium text-white", {
                                            "bg-red-400": shop.woytiReservationsCount < 1,
                                            "bg-green-400": shop.woytiReservationsCount > 0
                                        }),
                                        children: shop.woytiReservationsCount || "0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-48 w-full overflow-hidden flex justify-center items-center",
                                        children: ((ref = shop.organisation) === null || ref === void 0 ? void 0 : ref.logoUrl) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_image__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
                                            url: shop.organisation.logoUrl,
                                            alt: shop.name,
                                            width: 350,
                                            height: 200,
                                            sizes: "300px",
                                            className: "h-full w-auto"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-medium text-lg text-gray-600",
                                            children: shop.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-lg font-bold mb-1",
                                                children: shop.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "text-gray-600",
                                                children: [
                                                    (ref1 = shop.address) === null || ref1 === void 0 ? void 0 : ref1.street,
                                                    " ",
                                                    (ref2 = shop.address) === null || ref2 === void 0 ? void 0 : ref2.streetNumber,
                                                    ", ",
                                                    (ref3 = shop.address) === null || ref3 === void 0 ? void 0 : ref3.zipcode,
                                                    " ",
                                                    (ref4 = shop.address) === null || ref4 === void 0 ? void 0 : ref4.city,
                                                    ",",
                                                    " ",
                                                    (ref5 = shop.address) === null || ref5 === void 0 ? void 0 : ref5.country
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, shop._id);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
function Index(props) {
    if (props.error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_fallback_page_template__WEBPACK_IMPORTED_MODULE_11__/* .FallbackPageTemplate */ .w, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_error_boundary__WEBPACK_IMPORTED_MODULE_8__/* .ErrorFallback */ .H, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_page_template__WEBPACK_IMPORTED_MODULE_12__/* .PageTemplate */ .P, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_app_banner__WEBPACK_IMPORTED_MODULE_7__/* .AppBanner */ .y, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_general_page_header__WEBPACK_IMPORTED_MODULE_9__/* .GeneralPageHeader */ .T, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageImpl, {
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_page_footer__WEBPACK_IMPORTED_MODULE_10__/* .PageFooter */ .W, {})
        ]
    });
}


/***/ }),

/***/ 1748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ImageFitMode; },
/* harmony export */   "E": function() { return /* binding */ generateImageLink; }
/* harmony export */ });
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7563);

var ImageFitMode;
(function(ImageFitMode) {
    ImageFitMode["Clip"] = "clip";
    ImageFitMode["Crop"] = "crop";
    ImageFitMode["Fill"] = "fill";
})(ImageFitMode || (ImageFitMode = {}));
function generateImageLink(url) {
    let width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 400, height = arguments.length > 2 ? arguments[2] : void 0, fitMode = arguments.length > 3 ? arguments[3] : void 0;
    let transformations = [];
    transformations.push("w-".concat(width));
    if (height) {
        transformations.push("h-".concat(height));
    }
    switch(fitMode){
        case ImageFitMode.Clip:
            transformations.push("c-at_max");
            break;
        case ImageFitMode.Crop:
            transformations.push("c-maintain_ratio");
            break;
        case ImageFitMode.Fill:
            transformations.push("cm-pad_resize");
            transformations.push("bg-FFFFFF");
            break;
        default:
            break;
    }
    return "".concat(url, "?").concat((0,query_string__WEBPACK_IMPORTED_MODULE_0__.stringify)({
        tr: transformations.join(",")
    }));
}


/***/ }),

/***/ 1311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ formatPhonenumber; }
/* harmony export */ });
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1257);

function formatPhonenumber(phonenumber) {
    var ref;
    var ref1;
    return (ref1 = (ref = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_0__/* .parsePhoneNumberFromString */ ._)(phonenumber)) === null || ref === void 0 ? void 0 : ref.format("INTERNATIONAL")) !== null && ref1 !== void 0 ? ref1 : phonenumber;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);